// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D1qP589GltckuzmQ7qu4{margin-top:40px;margin-bottom:-2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `D1qP589GltckuzmQ7qu4`
};
export default ___CSS_LOADER_EXPORT___;
